"use strict";

(function () {
	const lifetime = 1500;
	const size = 60;
	const speed = 5;
	const distanceThreshold = 20;
	let lastPosition = {
		x: 0,
		y: 0
	};

	const images = ['//www.fooddepaux.com/cdn/shop/t/26/assets/sticker1.png?v=174508086066568738951771317898', '//www.fooddepaux.com/cdn/shop/t/26/assets/sticker2.png?v=117364586857122270781771317899', '//www.fooddepaux.com/cdn/shop/t/26/assets/sticker3.png?v=37922005899468470241771317899', '//www.fooddepaux.com/cdn/shop/t/26/assets/sticker4.png?v=162916369902485750631771317900', '//www.fooddepaux.com/cdn/shop/t/26/assets/sticker5.png?v=52760841120665365721771317900'];
	let currentImageIndex = 0;
	let recentStickers = [];
	const maxRecentHistory = images.length;
	const getNextImage = () => {
		const availableIndices = images.map((_, index) => index).filter(index => !recentStickers.includes(index));
		let nextIndex;
		if (availableIndices.length > 0) {
			// Берем случайный из доступных (не повторяющихся)
			nextIndex = availableIndices[Math.floor(Math.random() * availableIndices.length)];
		} else {
			// Если все использовались - берем любой кроме последнего
			do {
				nextIndex = Math.floor(Math.random() * images.length);
			} while (recentStickers.length > 0 && nextIndex === recentStickers[recentStickers.length - 1]);
		}

		// Обновляем историю последних стикеров
		recentStickers.push(nextIndex);
		if (recentStickers.length > maxRecentHistory) {
			recentStickers.shift(); // Удаляем самый старый
		}
		currentImageIndex = nextIndex;
		return images[nextIndex];
	};
	const createSticker = (x, y, wrapper = false) => {
		const sticker = document.createElement('div');
		sticker.classList.add('fd-sticker');
		const currentImage = getNextImage();
		const img = document.createElement('img');
		img.src = currentImage;
		sticker.style.left = `${x}px`;
		sticker.style.top = `${y}px`;
		sticker.appendChild(img);
		if (wrapper) {
			wrapper.appendChild(sticker);
		} else {
			document.body.appendChild(sticker);
		}
		animateSticker(sticker);
	};
	const animateSticker = sticker => {
		gsap.to(sticker, {
			delay: 1,
			opacity: 0,
			scale: .7,
			duration: 1,
			onComplete: () => {
				sticker.parentNode.removeChild(sticker);
			}
		});
	};

	// window.addEventListener('DOMContentLoaded', () => {
	const story = document.querySelector('.story .story-inner');
	story && story.addEventListener('mousemove', e => {
		// const currentX = e.clientX;
		// const currentY = e.clientY;
		const rect = story.getBoundingClientRect();
		const currentX = e.clientX - rect.left;
		const currentY = e.clientY - rect.top;
		const distance = Math.sqrt(Math.pow(currentX - lastPosition.x, 2) + Math.pow(currentY - lastPosition.y, 2));
		if (distance > distanceThreshold * (11 - speed)) {
			createSticker(currentX, currentY, story);
			lastPosition = {
				x: currentX,
				y: currentY
			};
		}
	});
	// });
})();
//# sourceMappingURL=stickers.js.map
